<template>

 <div class=" black map">

     <div class="gmap">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6133.2715305774145!2d-3.6770854953137198!3d50.99569605605197!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x486dc857f44ba5cf%3A0x3e9a9152145ef661!2sCopse+Corner+Music!5e0!3m2!1sen!2suk!4v1529965104713" width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
    </div>
    <div class="black info">
        
      <div class="address">
      <p>
        <strong>Address:</strong><br />
      Copse Corner Music <br />
      Knowstone Court, <br />
      Knowstone, <br />
      South Molton, <br />
      Devon <br />
      EX36 4RW </p>
      </div>
      <div class="info2">
      <p><strong>Telephone:</strong> O7595 33787O.</p>
      <p><em>
        Please note that visits to the studio are by appointment only.
      </em></p>
      </div>
    </div>
</div>

</template>

<script>
export default {
  name: 'map'
}
</script>

<style scoped lang="scss">
a{
  color: white;
  text-decoration: none;
  &:hover{
    color:orange;
  }
}
.map{
    display: flex;

    min-height: 0;
    height: auto;
    text-align: center;
}
.gmap{
    flex:1 1 auto;
}
.info{
    flex:0 0 300px;
    padding: 1em;
    text-align: left;
    display: block;
}
.info2, .address{
     flex: 1 1 50%; 
    }
@media only screen and (max-width: 600px) {
    .map{
        flex-wrap: wrap;
    }
    .info{
        flex: 1 1 50%;
        display: flex;
    }
    
}
</style>
